/**
 * Map name for mutations
 * @types {string}
 */
export const SET_COURSE_OPENED = "COURSE/SET_COURSE_OPENED";
export const SET_COURSE = "COURSE/SET_COURSE";
export const SET_FINISH_COURSE = "COURSE/SET_FINISH_COURSE";
export const SET_NEXT_COURSE_COUNT = "COURSE/SET_NEXT_COURSE_COUNT";
